import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import navigationMenuActions from 'redux/actions/navigationMenuActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import NavigationNotificationPreferencesView from 'views/navigation_menu/content/notification_preferences/view'
import notificationPreferencesSelector from 'redux/selectors/navigation_menu/navigation_menu_notification_preferences_selector'

class NavigationMenuNotificationPreferences extends PureComponent {

	componentDidMount() {
		this.props.actions.initialize()
	}

	updateEmailNotification = value => (
		this.props.actions.updateEmailNotification(value)
	)

	render() {
		return (
			<NavigationNotificationPreferencesView
				navigateTo={this.props.navigateTo}
				isEmailNotificationEnabled={
					this.props.isEmailNotificationEnabled
				}
				updateEmailNotification={this.updateEmailNotification}
			/>
		)
	}
}

function mapStateToProps(state) {
	return notificationPreferencesSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		initialize: navigationMenuActions.notificationPreferencesInitialize,
		updateEmailNotification: navigationMenuActions.updateEmailNotification,
	}, dispatch)
}

NavigationMenuNotificationPreferences.propTypes = {
	navigateTo: PropTypes.func,
	actions: PropTypes.shape({
		initialize: PropTypes.func.isRequired,
		updateEmailNotification: PropTypes.func.isRequired,
	}),
	isEmailNotificationEnabled: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(
	NavigationMenuNotificationPreferences
)
